import { faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { i18n } from 'src/i18n';
import Errors from 'src/modules/shared/error/errors';
import PromptForm from 'src/view/prompt/form/PromptForm';
import PromptService from 'src/modules/prompt/promptService';
import layoutSelectors from 'src/modules/layout/layoutSelectors';
import { useSelector } from 'react-redux';
import Message from 'src/view/shared/message';

function PromptFormModal(props) {
  const [saveLoading, setSaveLoading] = useState(false);

  const doSubmit = async (_, data) => {
    try {
      setSaveLoading(true);
      let record;
      if (props.isEditing) {
        await PromptService.update(props.record.id, data);
        Message.success(i18n('entities.prompt.update.success'));
        record = await PromptService.find(props.record.id);
      } else {
        const { id } = await PromptService.create(data);
        Message.success(i18n('entities.prompt.create.success'));
        record = await PromptService.find(id);
      }
      props.onSuccess(record);
    } catch (error) {
      Errors.handle(error);
    } finally {
      setSaveLoading(false);
    }
  };

  const isDarkMode = useSelector(layoutSelectors.selectDarkMode);

  return ReactDOM.createPortal(
    <div className={`${isDarkMode ? 'dark' : ''}`}>
      <div
        className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'
        tabIndex={-1}>
        <div
          className='relative mx-auto w-auto max-h-screen pt-6 pb-6'
          onClick={(event) => event.stopPropagation()}>
          {(props.isEditing && !props.initLoading) || !props.isEditing ? (
            <div className='relative flex flex-col w-full border-0 rounded-lg shadow-lg outline-none dark:bg-gray-800 dark:text-white group bg-white'>
              <div className='flex items-start justify-between p-5 rounded-t'>
                <div className='text-lg font-semibold'>
                  {props.isEditing
                    ? i18n('entities.prompt.edit.title')
                    : i18n('entities.prompt.new.title')}
                </div>

                <button
                  type='button'
                  className='ml-auto bg-transparent border-0 text-gray-900 float-right text-lg leading-none font-semibold outline-none focus:outline-none'
                  onClick={props.onClose}>
                  <span className='bg-transparent text-gray-200 h-6 w-6 text-lg block outline-none focus:outline-none'>
                    <FontAwesomeIcon icon={faTimes} />
                  </span>
                </button>
              </div>{' '}
              <hr className='bg-white mb-2 mx-6' />
              <div className='relative p-6 flex-auto '>
                <PromptForm
                  saveLoading={saveLoading}
                  onSubmit={doSubmit}
                  onCancel={props.onClose}
                  record={props.record}
                  isEditing={props.isEditing}
                  modal
                />
              </div>
            </div>
          ) : (
            <div className='text-center'>
              <FontAwesomeIcon
                icon={faSpinner}
                spin={true}
                size='2x'
                color='#fff'
              />
            </div>
          )}
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
    </div>,
    (document as any).getElementById('modal-root')
  );
}

export default PromptFormModal;
